import { getSubscriptionCharge } from "src/api/subscription";
export const getMixpanelOrderType = (orderType)=>{
    if (orderType === "package") return "package";
    // 이용권 단품·월구독·업그레이드는 모두 이용권(멤버십) 계열 주문이다
    if (orderType === "pass" || orderType === "subscription" || orderType === "upgrade") return "membership";
    return "separate";
};
/**
 * mixpanel 'Product Title' / 'Product Price' — 결제 대상 상품의 표시 정보.
 *
 * orderType 마다 응답 스키마가 달라(union) 호출부에서 매번 좁히지 않도록 여기서 한 번만 판별한다.
 * 캐시 충전(GetCashItemResponse)은 상품 목록 응답이라 단일 상품이 없어 undefined 로 돌려준다.
 */ export const getTrackedProduct = (paymentData)=>{
    // 월구독 — 이번 회차 청구액(체험이면 0)이 '결제 대상 가격'이다
    if ("alreadySubscribed" in paymentData) {
        return {
            title: paymentData.title,
            price: getSubscriptionCharge(paymentData).currentCharge
        };
    }
    if ("total" in paymentData) {
        return {
            title: paymentData.title,
            price: paymentData.total
        };
    }
    if ("title" in paymentData) {
        return {
            title: paymentData.title,
            price: paymentData.price
        };
    }
    return {
        title: undefined,
        price: undefined
    };
};
/** 이용권(멤버십) 계열 주문의 BE orderType 코드 — ORDER_TYPE_CATEGORIES 참고 */ const MEMBERSHIP_ORDER_TYPE_CODES = [
    1,
    4,
    5,
    6,
    7,
    9,
    13
];
/** 패키지 주문의 BE orderType 코드 */ const PACKAGE_ORDER_TYPE_CODE = 8;
/**
 * 완료 페이지용 'Order Type'.
 * 주문 응답의 orderType 은 라우터 문자열이 아니라 숫자 코드라 별도로 매핑한다.
 */ export const getMixpanelOrderTypeFromCode = (orderTypeCode)=>{
    if (orderTypeCode === PACKAGE_ORDER_TYPE_CODE) return "package";
    if (MEMBERSHIP_ORDER_TYPE_CODES.includes(orderTypeCode)) return "membership";
    return "separate";
};
